import { NgModule } from '@angular/core';
import { MainShellModule } from '@main/shell';
import { SdvorMainUiModule } from '@sdvor/main/ui';

@NgModule({
  imports: [SdvorMainUiModule, MainShellModule],
  exports: [SdvorMainUiModule],
})
export class SdvorMainShellModule {}
